import React from 'react';
import {
  Activity, Award, Bell, Calendar, Check, CheckCircle, CircleAlert, CircleDot,
  Clock3, Crown, Flag, Flame, Globe2, Heart, Info, MapPin, Medal, MessageCircle,
  PackageOpen, PartyPopper, Pin, Rocket, Search, Shield, Star, Target, Trophy,
  User, UserPlus, Users, X, Zap
} from 'lucide-react';

const icons = {
  activity: Activity,
  award: Award,
  bell: Bell,
  calendar: Calendar,
  check: Check,
  success: CheckCircle,
  error: CircleAlert,
  match: CircleDot,
  clock: Clock3,
  crown: Crown,
  flag: Flag,
  flame: Flame,
  globe: Globe2,
  heart: Heart,
  info: Info,
  location: MapPin,
  medal: Medal,
  message: MessageCircle,
  empty: PackageOpen,
  celebration: PartyPopper,
  pin: Pin,
  rocket: Rocket,
  search: Search,
  shield: Shield,
  star: Star,
  target: Target,
  trophy: Trophy,
  user: User,
  userPlus: UserPlus,
  users: Users,
  close: X,
  zap: Zap
};

const legacyNames = {
  '⚽': 'match', '🏆': 'trophy', '🔥': 'flame', '❤️': 'heart', '⭐': 'star',
  '📍': 'location', '🎯': 'target', '👤': 'user', '👥': 'users', '💬': 'message',
  '🔔': 'bell', '⚙️': 'activity', '🏅': 'medal', '🚀': 'rocket', '📅': 'calendar',
  '🏀': 'activity', '🎾': 'activity', '🏃': 'activity', '🏊': 'activity',
  '🚴': 'activity', '🏐': 'activity', '🏸': 'activity', '🌍': 'globe', '🔍': 'search',
  '✅': 'success', '❌': 'error', '⚠️': 'error', '🚩': 'flag', '📊': 'activity',
  '📭': 'empty', '💳': 'activity', '🆓': 'award', '🎉': 'celebration', '✨': 'star',
  '👑': 'crown', '👍': 'success', '⛔': 'shield', '🕐': 'clock', '🔐': 'shield',
  '✕': 'close', '✓': 'check', '➕': 'target', '📧': 'message', '👁️': 'activity'
};

export default function AppIcon({ name, size = 20, strokeWidth = 2, ...props }) {
  const key = legacyNames[name] || name;
  const Icon = icons[key] || Activity;
  return <Icon size={size} strokeWidth={strokeWidth} aria-hidden="true" {...props} />;
}

export { legacyNames };
